import { Link, useLocation } from "react-router-dom";
import { BAY_ISLE, TERRACOTTA, PROPER_GREY, RULE, WHITE, FONT_DISPLAY, FONT_BODY } from "../theme";

const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/for-agents", label: "For Agents" },
  { to: "/for-businesses", label: "For Businesses" },
  { to: "/products", label: "Products" },
  { to: "/contact", label: "Contact" },
];


export default function Nav() {
  const location = useLocation();

  return (
    <div style={{
      borderBottom: `1px solid ${RULE}`, background: WHITE,
      padding: "13px 24px", display: "flex", alignItems: "center", justifyContent: "space-between",
      position: "sticky", top: 0, zIndex: 50, flexWrap: "wrap", gap: 12,
    }}>
      <Link to="/" style={{ display: "flex", alignItems: "center", gap: 11, textDecoration: "none" }}>
        <img
          src="/assets/acadia-logo.png"
          alt="Acadia Media & Marketing"
          style={{ height: 44, width: 44, objectFit: "contain", flexShrink: 0 }}
        />
        <div>
          <p style={{ fontSize: 13, fontWeight: 700, color: BAY_ISLE, lineHeight: 1, fontFamily: FONT_DISPLAY }}>
            Acadia Media & Marketing
          </p>
          <p style={{ fontSize: 9, color: PROPER_GREY, letterSpacing: "0.12em", textTransform: "uppercase", fontFamily: FONT_BODY }}>
            Hudson Valley Marketing
          </p>
        </div>
      </Link>

      <div style={{ display: "flex", alignItems: "center", gap: 4, flexWrap: "wrap" }}>
        {NAV_LINKS.map(link => {
          const active = location.pathname === link.to;
          return (
            <Link
              key={link.to}
              to={link.to}
              style={{
                fontSize: 12, fontWeight: 600, padding: "6px 11px", borderRadius: 999,
                textDecoration: "none", fontFamily: FONT_BODY,
                color: active ? WHITE : BAY_ISLE,
                background: active ? BAY_ISLE : "transparent",
                transition: "all 0.15s",
              }}
            >
              {link.label}
            </Link>
          );
        })}
        <Link
          to="/get-started"
          style={{
            fontSize: 12, fontWeight: 700, padding: "8px 16px", borderRadius: 999,
            textDecoration: "none", fontFamily: FONT_BODY, marginLeft: 6,
            color: WHITE, background: TERRACOTTA, letterSpacing: "0.04em",
            transition: "opacity 0.15s",
          }}
        >
          Get Started →
        </Link>
      </div>
    </div>
  );
}
